<template>
  <div class="drawer">
    <el-drawer :visible.sync="drawer"
               :with-header="withHeader"
               :before-close="handleClose"
               :show-close="false">
      <slot name="header"></slot>
      <div class="drwer-container">
        <formCommon :form-array="formArray"
                    :initial-form-label-align="initialFormLabelAlign"
                    :rules="drawerRules"
                    @getData="getData"
                    @handleIcon="$emit('handleIcon')" />
        <slot name="footer"></slot>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import formCommon from '@/components/form/formCommon.vue';

export default {
  components: { formCommon },
  data() {
    return {
      drawer: true,
    };
  },
  props: {
    formArray: {
      type: Array,
      default() {
        return [];
      },
    },
    withHeader: {
      type: Boolean,
      default() {
        return true;
      },
    },
    drawerRules: {
      type: Object,
      default() {
        return {};
      },
    },
    initialFormLabelAlign: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose');
    },
    getData(val) {
      this.$emit('onSubmit', val);
    },
  },
};
</script>
<style lang='less' scoped>
.drawer{
  color: #606266;
  ::v-deep header#el-drawer__title{
    margin-bottom: 0;
    padding: 0;
  }
  ::v-deep .el-drawer__body{
    height: 100%;
  }
  .drwer-container{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
